import { t } from 'i18next';
import moment from 'moment';
import { useEffect, useState } from 'react';

import avatar5 from '../../assets/img/avatar_5.svg';
import arrowWhiteIcon from '../../assets/img/icons/arrow_right_white.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import AssigneeTooltip from '../../components/Tooltip/AssigneeTooltip';
import {
  TableItem,
  TableRowAndBudgetCollapseContainer,
} from '../../styledComponents/ProjectsNew';
import {
  CommonFlex,
  Container,
  TableText,
} from '../../styledComponents/common';
import { ItemsTransactionsReportTable } from '../../styledComponents/itemsTransactionsReport';
import { ExpandIcon, ProjectExpandButton } from '../Projects/projectsStyles';
import TaskEvidence from '../Tasks/TaskDetails/taskEvidence';
import { AssigneeRoundImg, CollapseSection } from '../Tasks/tasksStyles';

const ItemsCountingReportList = ({ isLoading, itemsCountingReport }) => {
  console.log(
    '🚀 ~ ItemsCountingReportList.jsx:25 ~ itemsCountingReport:',
    itemsCountingReport,
  );
  const [list, setList] = useState([]);
  console.log('🚀 ~ ItemsCountingReportList.jsx:26 ~ list:', list);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (itemsCountingReport && itemsCountingReport.length > 0) {
      const updatedList = itemsCountingReport.map(item => ({
        ...item,
        item_name: item.item_name,
        quantity: item.quantity,
        current_quantity: item.current_quantity,
        remaining: item.remaining,
        created_at: item.created_at,
        task_code: item.task_code,
        public_zone_name: item.public_zone_name,
        office: item.office,
        assignee: item.assignee,
        employee_note: item.employee_note,
      }));
      setList(updatedList);
    } else {
      setList([]);
    }
  }, [itemsCountingReport]);

  const handleExpandClick = item => {
    if (selectedItem && selectedItem.id === item.id) {
      setSelectedItem(null); // Collapse if already selected
    } else {
      setSelectedItem(item); // Expand the selected item
    }
  };

  return (
    <Container style={{ paddingBottom: '20px', overflowX: 'auto' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : list && list.length > 0 ? (
        <>
          <ItemsTransactionsReportTable heading>
            <TableItem>
              <TableText>{t('task_code')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('public_zone')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('office')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('assignee')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('created_at')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('item_name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('current_quantity')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('counted_quantity')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('difference')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('employee_note')}</TableText>
            </TableItem>
            <TableItem />
          </ItemsTransactionsReportTable>
          {list.map(item => (
            <TableRowAndBudgetCollapseContainer key={item.id}>
              <ItemsTransactionsReportTable>
                <TableItem>
                  <TableText>{item.task_code}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{item.public_zone_name}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{item.office}</TableText>
                </TableItem>
                <TableItem>
                  {item.assignees.id ? (
                    <AssigneeRoundImg image={item.assignees.avatar || avatar5}>
                      <AssigneeTooltip
                        toolTipText={`${
                          item.assignees.first_name
                            ? ` ${item.assignees.first_name}`
                            : ``
                        }${
                          item.assignees.last_name
                            ? ` ${item.assignees.last_name}`
                            : ``
                        }${
                          item.assignees.name ? ` ${item.assignees.name}` : ``
                        }`}
                        phone={item.assignees.phone}
                        top="-60px"
                        left="-55px"
                      />
                    </AssigneeRoundImg>
                  ) : null}
                </TableItem>
                <TableItem>
                  <TableText>
                    {moment(item.created_at).format('DD/MM/YYYY HH:mm')}
                  </TableText>
                </TableItem>
                <TableItem>
                  <TableText>{item.item_name}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{item.current_quantity}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{item.quantity}</TableText>
                </TableItem>
                <TableItem>
                  <TableText
                    style={{
                      color:
                        item.quantity - item.current_quantity < 0
                          ? 'red'
                          : 'inherit',
                    }}
                  >
                    {item.quantity - item.current_quantity}
                  </TableText>
                </TableItem>
                <TableItem>
                  <TableText>{item.employee_note}</TableText>
                </TableItem>
                <TableItem alignContent="start">
                  <CommonFlex gap="12px" wrap="wrap">
                    <ProjectExpandButton
                      margin="0"
                      onClick={() => handleExpandClick(item)}
                    >
                      <ExpandIcon
                        src={arrowWhiteIcon}
                        alt=""
                        open={selectedItem && selectedItem.id === item.id}
                      />
                    </ProjectExpandButton>
                  </CommonFlex>
                </TableItem>
              </ItemsTransactionsReportTable>
              <CollapseSection open={selectedItem?.id === item.id}>
                <Container padding="30px" borderColor="#977C70" margin="20px">
                  <TaskEvidence evidences={item.evidences} />
                </Container>
              </CollapseSection>
            </TableRowAndBudgetCollapseContainer>
          ))}
        </>
      ) : (
        <NoDataComponent
          title={'No Counting Report Found'}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default ItemsCountingReportList;
